import it from './it.json'
import terms from './terms'

const messages = {
  ...it,
  terms,
}

export default messages
